/* Gerado por tools/gerar-magias.py — não edite à mão. */

import { tabelaAtual, type TabelaCombate } from './combateTabela';

export type MagiaId =
  'clumsy' |
  'create-food' |
  'feeblemind' |
  'heal' |
  'magic-arrow' |
  'night-sight' |
  'reactive-armor' |
  'weaken' |
  'agility' |
  'cunning' |
  'cure' |
  'harm' |
  'magic-trap' |
  'magic-untrap' |
  'protection' |
  'strength' |
  'bless' |
  'fireball' |
  'magic-lock' |
  'poison' |
  'telekinesis' |
  'teleport' |
  'unlock' |
  'wall-of-stone' |
  'arch-cure' |
  'arch-protection' |
  'curse' |
  'fire-field' |
  'greater-heal' |
  'lightning' |
  'mana-drain' |
  'recall' |
  'blade-spirits' |
  'dispel-field' |
  'incognito' |
  'magic-reflection' |
  'mind-blast' |
  'paralyze' |
  'poison-field' |
  'summon-creature' |
  'dispel' |
  'energy-bolt' |
  'explosion' |
  'invisibility' |
  'mark' |
  'mass-curse' |
  'paralyze-field' |
  'reveal' |
  'chain-lightning' |
  'energy-field' |
  'flamestrike' |
  'gate-travel' |
  'mana-vampire' |
  'mass-dispel' |
  'meteor-swarm' |
  'polymorph' |
  'earthquake' |
  'energy-vortex' |
  'resurrection' |
  'summon-air-elemental' |
  'summon-daemon' |
  'summon-earth-elemental' |
  'summon-fire-elemental' |
  'summon-water-elemental';

export type MagiaKind = 'damage' | 'poison' | 'cure' | 'heal' | 'paralyze' | 'buff' | 'debuff' | 'dispel' | 'resurrect';

export interface Magia {
  readonly id: MagiaId;
  /** Nome em português, como aparece na interface. */
  readonly nome: string;
  /** Nome no jogo, em inglês — é como o jogador procura. */
  readonly nomeEn: string;
  /** Palavras de poder — o que o personagem fala ao conjurar. */
  readonly palavras: string;
  /** Página do grimório, 1 a 8. */
  readonly pagina: number;
  /** Posição dentro da página, 1 a 8 (ordem do livro do UO). */
  readonly posicao: number;
  mana: number;
  /** Magia mínima para tentar conjurar. */
  readonly skillMin: number;
  /** Magia em que a chance chega a 100%. */
  readonly skillFull: number;
  danoMin?: number;
  danoMax?: number;
  alcance?: number;
  atrasoMs?: number;
  /**
   * O `Kind` do servidor, para as magias que o simulador resolve. Ausente =
   * magia que ainda nao existe em combate. E o unico jeito honesto de o
   * cliente saber o que e magia de ataque: `danoMin > 0` derrubaria o Golpe
   * Mental, cujo dano depende da Inteligencia do alvo.
   */
  readonly kind?: MagiaKind;
}

/** Self cast (V + tecla): cura, cura de veneno e buff. Ataque, debuff e as utilidades sem efeito no servidor ficam de fora. */
export function aceitaAutoAlvo(m: Magia): boolean {
  return m.kind === 'heal' || m.kind === 'cure' || m.kind === 'buff';
}

export const MAGIAS: Record<MagiaId, Magia> = {
  'clumsy': { id: 'clumsy', nome: "Desajeitar", nomeEn: "Clumsy", palavras: "Uus Jux", pagina: 1, posicao: 1, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'debuff' },
  'create-food': { id: 'create-food', nome: "Criar Comida", nomeEn: "Create Food", palavras: "In Mani Ylem", pagina: 1, posicao: 2, mana: 4, skillMin: 1.1, skillFull: 40.1 },
  'feeblemind': { id: 'feeblemind', nome: "Debilitar Mente", nomeEn: "Feeblemind", palavras: "Rel Wis", pagina: 1, posicao: 3, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'debuff' },
  'heal': { id: 'heal', nome: "Curar", nomeEn: "Heal", palavras: "In Mani", pagina: 1, posicao: 4, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'heal' },
  'magic-arrow': { id: 'magic-arrow', nome: "Flecha Mágica", nomeEn: "Magic Arrow", palavras: "In Por Ylem", pagina: 1, posicao: 5, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 3, danoMax: 7, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'night-sight': { id: 'night-sight', nome: "Visão Noturna", nomeEn: "Night Sight", palavras: "In Lor", pagina: 1, posicao: 6, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'buff' },
  'reactive-armor': { id: 'reactive-armor', nome: "Armadura Reativa", nomeEn: "Reactive Armor", palavras: "Flam Sanct", pagina: 1, posicao: 7, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 0, atrasoMs: 0, kind: 'buff' },
  'weaken': { id: 'weaken', nome: "Enfraquecer", nomeEn: "Weaken", palavras: "Des Mani", pagina: 1, posicao: 8, mana: 4, skillMin: 1.1, skillFull: 40.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'debuff' },
  'agility': { id: 'agility', nome: "Agilidade", nomeEn: "Agility", palavras: "Ex Uus", pagina: 2, posicao: 1, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'buff' },
  'cunning': { id: 'cunning', nome: "Astúcia", nomeEn: "Cunning", palavras: "Uus Wis", pagina: 2, posicao: 2, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'buff' },
  'cure': { id: 'cure', nome: "Curar Veneno", nomeEn: "Cure", palavras: "An Nox", pagina: 2, posicao: 3, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'cure' },
  'harm': { id: 'harm', nome: "Ferir", nomeEn: "Harm", palavras: "An Mani", pagina: 2, posicao: 4, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 6, danoMax: 11, alcance: 8, atrasoMs: 0, kind: 'damage' },
  'magic-trap': { id: 'magic-trap', nome: "Armadilha Mágica", nomeEn: "Magic Trap", palavras: "In Jux", pagina: 2, posicao: 5, mana: 6, skillMin: 6.1, skillFull: 50.1 },
  'magic-untrap': { id: 'magic-untrap', nome: "Desarmar Armadilha", nomeEn: "Magic Untrap", palavras: "An Jux", pagina: 2, posicao: 6, mana: 6, skillMin: 6.1, skillFull: 50.1 },
  'protection': { id: 'protection', nome: "Proteção", nomeEn: "Protection", palavras: "Uus Sanct", pagina: 2, posicao: 7, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 0, danoMax: 0, alcance: 0, atrasoMs: 0, kind: 'buff' },
  'strength': { id: 'strength', nome: "Força", nomeEn: "Strength", palavras: "Uus Mani", pagina: 2, posicao: 8, mana: 6, skillMin: 6.1, skillFull: 50.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'buff' },
  'bless': { id: 'bless', nome: "Bênção", nomeEn: "Bless", palavras: "Rel Sanct", pagina: 3, posicao: 1, mana: 9, skillMin: 16.1, skillFull: 60.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'buff' },
  'fireball': { id: 'fireball', nome: "Bola de Fogo", nomeEn: "Fireball", palavras: "Vas Flam", pagina: 3, posicao: 2, mana: 9, skillMin: 16.1, skillFull: 60.1, danoMin: 8, danoMax: 14, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'magic-lock': { id: 'magic-lock', nome: "Trancar", nomeEn: "Magic Lock", palavras: "An Por", pagina: 3, posicao: 3, mana: 9, skillMin: 16.1, skillFull: 60.1 },
  'poison': { id: 'poison', nome: "Envenenar", nomeEn: "Poison", palavras: "In Nox", pagina: 3, posicao: 4, mana: 9, skillMin: 16.1, skillFull: 60.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'poison' },
  'telekinesis': { id: 'telekinesis', nome: "Telecinesia", nomeEn: "Telekinesis", palavras: "Ort Por Ylem", pagina: 3, posicao: 5, mana: 9, skillMin: 16.1, skillFull: 60.1 },
  'teleport': { id: 'teleport', nome: "Teleporte", nomeEn: "Teleport", palavras: "Rel Por", pagina: 3, posicao: 6, mana: 9, skillMin: 16.1, skillFull: 60.1 },
  'unlock': { id: 'unlock', nome: "Destrancar", nomeEn: "Unlock", palavras: "Ex Por", pagina: 3, posicao: 7, mana: 9, skillMin: 16.1, skillFull: 60.1 },
  'wall-of-stone': { id: 'wall-of-stone', nome: "Muro de Pedra", nomeEn: "Wall of Stone", palavras: "In Sanct Ylem", pagina: 3, posicao: 8, mana: 9, skillMin: 16.1, skillFull: 60.1 },
  'arch-cure': { id: 'arch-cure', nome: "Cura em Área", nomeEn: "Arch Cure", palavras: "Vas An Nox", pagina: 4, posicao: 1, mana: 11, skillMin: 26.1, skillFull: 70.1 },
  'arch-protection': { id: 'arch-protection', nome: "Proteção em Área", nomeEn: "Arch Protection", palavras: "Vas Uus Sanct", pagina: 4, posicao: 2, mana: 11, skillMin: 26.1, skillFull: 70.1, danoMin: 0, danoMax: 0, alcance: 0, atrasoMs: 0, kind: 'buff' },
  'curse': { id: 'curse', nome: "Maldição", nomeEn: "Curse", palavras: "Des Sanct", pagina: 4, posicao: 3, mana: 11, skillMin: 26.1, skillFull: 70.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'debuff' },
  'fire-field': { id: 'fire-field', nome: "Campo de Fogo", nomeEn: "Fire Field", palavras: "In Flam Grav", pagina: 4, posicao: 4, mana: 11, skillMin: 26.1, skillFull: 70.1 },
  'greater-heal': { id: 'greater-heal', nome: "Cura Maior", nomeEn: "Greater Heal", palavras: "In Vas Mani", pagina: 4, posicao: 5, mana: 11, skillMin: 26.1, skillFull: 70.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'heal' },
  'lightning': { id: 'lightning', nome: "Relâmpago", nomeEn: "Lightning", palavras: "Por Ort Grav", pagina: 4, posicao: 6, mana: 11, skillMin: 26.1, skillFull: 70.1, danoMin: 11, danoMax: 18, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'mana-drain': { id: 'mana-drain', nome: "Drenar Mana", nomeEn: "Mana Drain", palavras: "Ort Rel", pagina: 4, posicao: 7, mana: 11, skillMin: 26.1, skillFull: 70.1 },
  'recall': { id: 'recall', nome: "Recall", nomeEn: "Recall", palavras: "Kal Ort Por", pagina: 4, posicao: 8, mana: 0, skillMin: 26.1, skillFull: 70.1 },
  'blade-spirits': { id: 'blade-spirits', nome: "Espíritos-Lâmina", nomeEn: "Blade Spirits", palavras: "In Jux Hur Ylem", pagina: 5, posicao: 1, mana: 14, skillMin: 36.1, skillFull: 80.1 },
  'dispel-field': { id: 'dispel-field', nome: "Dissipar Campo", nomeEn: "Dispel Field", palavras: "An Grav", pagina: 5, posicao: 2, mana: 14, skillMin: 36.1, skillFull: 80.1 },
  'incognito': { id: 'incognito', nome: "Incógnito", nomeEn: "Incognito", palavras: "Kal In Ex", pagina: 5, posicao: 3, mana: 14, skillMin: 36.1, skillFull: 80.1 },
  'magic-reflection': { id: 'magic-reflection', nome: "Reflexão Mágica", nomeEn: "Magic Reflection", palavras: "In Jux Sanct", pagina: 5, posicao: 4, mana: 14, skillMin: 36.1, skillFull: 80.1, danoMin: 0, danoMax: 0, alcance: 0, atrasoMs: 0, kind: 'buff' },
  'mind-blast': { id: 'mind-blast', nome: "Golpe Mental", nomeEn: "Mind Blast", palavras: "Por Corp Wis", pagina: 5, posicao: 5, mana: 14, skillMin: 36.1, skillFull: 80.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'paralyze': { id: 'paralyze', nome: "Paralisar", nomeEn: "Paralyze", palavras: "An Ex Por", pagina: 5, posicao: 6, mana: 14, skillMin: 36.1, skillFull: 80.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'paralyze' },
  'poison-field': { id: 'poison-field', nome: "Campo Venenoso", nomeEn: "Poison Field", palavras: "In Nox Grav", pagina: 5, posicao: 7, mana: 14, skillMin: 36.1, skillFull: 80.1 },
  'summon-creature': { id: 'summon-creature', nome: "Invocar Criatura", nomeEn: "Summon Creature", palavras: "Kal Xen", pagina: 5, posicao: 8, mana: 14, skillMin: 36.1, skillFull: 80.1 },
  'dispel': { id: 'dispel', nome: "Dissipar", nomeEn: "Dispel", palavras: "An Ort", pagina: 6, posicao: 1, mana: 20, skillMin: 51.8, skillFull: 90.1, danoMin: 0, danoMax: 0, alcance: 10, atrasoMs: 0, kind: 'dispel' },
  'energy-bolt': { id: 'energy-bolt', nome: "Raio de Energia", nomeEn: "Energy Bolt", palavras: "Corp Por", pagina: 6, posicao: 2, mana: 20, skillMin: 51.8, skillFull: 90.1, danoMin: 15, danoMax: 24, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'explosion': { id: 'explosion', nome: "Explosão", nomeEn: "Explosion", palavras: "Vas Ort Flam", pagina: 6, posicao: 3, mana: 20, skillMin: 51.8, skillFull: 90.1, danoMin: 15, danoMax: 24, alcance: 10, atrasoMs: 2500, kind: 'damage' },
  'invisibility': { id: 'invisibility', nome: "Invisibilidade", nomeEn: "Invisibility", palavras: "An Lor Xen", pagina: 6, posicao: 4, mana: 20, skillMin: 51.8, skillFull: 90.1 },
  'mark': { id: 'mark', nome: "Marcar", nomeEn: "Mark", palavras: "Kal Por Ylem", pagina: 6, posicao: 5, mana: 20, skillMin: 51.8, skillFull: 90.1 },
  'mass-curse': { id: 'mass-curse', nome: "Maldição em Massa", nomeEn: "Mass Curse", palavras: "Vas Des Sanct", pagina: 6, posicao: 6, mana: 20, skillMin: 51.8, skillFull: 90.1 },
  'paralyze-field': { id: 'paralyze-field', nome: "Campo Paralisante", nomeEn: "Paralyze Field", palavras: "In Ex Grav", pagina: 6, posicao: 7, mana: 20, skillMin: 51.8, skillFull: 90.1 },
  'reveal': { id: 'reveal', nome: "Revelar", nomeEn: "Reveal", palavras: "Wis Quas", pagina: 6, posicao: 8, mana: 20, skillMin: 51.8, skillFull: 90.1 },
  'chain-lightning': { id: 'chain-lightning', nome: "Relâmpago em Cadeia", nomeEn: "Chain Lightning", palavras: "Vas Ort Grav", pagina: 7, posicao: 1, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'energy-field': { id: 'energy-field', nome: "Campo de Energia", nomeEn: "Energy Field", palavras: "In Sanct Grav", pagina: 7, posicao: 2, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'flamestrike': { id: 'flamestrike', nome: "Golpe Flamejante", nomeEn: "Flamestrike", palavras: "Kal Vas Flam", pagina: 7, posicao: 3, mana: 40, skillMin: 66.1, skillFull: 100.1, danoMin: 24, danoMax: 36, alcance: 10, atrasoMs: 0, kind: 'damage' },
  'gate-travel': { id: 'gate-travel', nome: "Portal", nomeEn: "Gate Travel", palavras: "Vas Rel Por", pagina: 7, posicao: 4, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'mana-vampire': { id: 'mana-vampire', nome: "Vampiro de Mana", nomeEn: "Mana Vampire", palavras: "Ort Sanct", pagina: 7, posicao: 5, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'mass-dispel': { id: 'mass-dispel', nome: "Dissipar em Massa", nomeEn: "Mass Dispel", palavras: "Vas An Ort", pagina: 7, posicao: 6, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'meteor-swarm': { id: 'meteor-swarm', nome: "Chuva de Meteoros", nomeEn: "Meteor Swarm", palavras: "Kal Des Flam Ylem", pagina: 7, posicao: 7, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'polymorph': { id: 'polymorph', nome: "Polimorfia", nomeEn: "Polymorph", palavras: "Vas Ylem Rel", pagina: 7, posicao: 8, mana: 40, skillMin: 66.1, skillFull: 100.1 },
  'earthquake': { id: 'earthquake', nome: "Terremoto", nomeEn: "Earthquake", palavras: "In Vas Por", pagina: 8, posicao: 1, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'energy-vortex': { id: 'energy-vortex', nome: "Vórtice de Energia", nomeEn: "Energy Vortex", palavras: "Vas Corp Por", pagina: 8, posicao: 2, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'resurrection': { id: 'resurrection', nome: "Ressurreição", nomeEn: "Resurrection", palavras: "An Corp", pagina: 8, posicao: 3, mana: 50, skillMin: 80.1, skillFull: 120.1, danoMin: 0, danoMax: 0, alcance: 1, atrasoMs: 0, kind: 'resurrect' },
  'summon-air-elemental': { id: 'summon-air-elemental', nome: "Invocar Elemental do Ar", nomeEn: "Summon Air Elemental", palavras: "Kal Vas Xen Hur", pagina: 8, posicao: 4, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'summon-daemon': { id: 'summon-daemon', nome: "Invocar Demônio", nomeEn: "Summon Daemon", palavras: "Kal Vas Xen Corp", pagina: 8, posicao: 5, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'summon-earth-elemental': { id: 'summon-earth-elemental', nome: "Invocar Elemental da Terra", nomeEn: "Summon Earth Elemental", palavras: "Kal Vas Xen Ylem", pagina: 8, posicao: 6, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'summon-fire-elemental': { id: 'summon-fire-elemental', nome: "Invocar Elemental do Fogo", nomeEn: "Summon Fire Elemental", palavras: "Kal Vas Xen Flam", pagina: 8, posicao: 7, mana: 50, skillMin: 80.1, skillFull: 120.1 },
  'summon-water-elemental': { id: 'summon-water-elemental', nome: "Invocar Elemental da Água", nomeEn: "Summon Water Elemental", palavras: "Kal Vas Xen An Flam", pagina: 8, posicao: 8, mana: 50, skillMin: 80.1, skillFull: 120.1 },
};

const IDS = new Set<string>(Object.keys(MAGIAS));

export function ehMagia(id: string): id is MagiaId {
  return IDS.has(id);
}

/** Magias que o simulador resolve — dano, veneno e cura. O grimório lista 64. */
export function ehMagiaPronta(id: MagiaId): boolean {
  return MAGIAS[id].danoMin !== undefined;
}

/** A mesma conta do `CombatMath.SuccessChance` do servidor. */
export function chanceDeSucesso(magery: number, min: number, full: number): number {
  const span = full - min;
  if (span <= 0) return 1;
  return Math.min(1, Math.max(0, (magery - min) / span));
}

export const ICONE_PADRAO = '/sprites/itens/skills/_default.png';

export function iconeDaMagia(id: MagiaId): string {
  return `/sprites/itens/skills/${id}.png`;
}

/** Porta de entrada para id vindo de fora. Id desconhecido vira o ícone padrão. */
export function iconeSeguro(id: string): string {
  if (!ehMagia(id)) {
    console.warn('magia desconhecida', id);
    return ICONE_PADRAO;
  }
  return iconeDaMagia(id);
}

export const PAGINAS: ReadonlyArray<ReadonlyArray<Magia>> = [
  [MAGIAS['clumsy'], MAGIAS['create-food'], MAGIAS['feeblemind'], MAGIAS['heal'], MAGIAS['magic-arrow'], MAGIAS['night-sight'], MAGIAS['reactive-armor'], MAGIAS['weaken']],
  [MAGIAS['agility'], MAGIAS['cunning'], MAGIAS['cure'], MAGIAS['harm'], MAGIAS['magic-trap'], MAGIAS['magic-untrap'], MAGIAS['protection'], MAGIAS['strength']],
  [MAGIAS['bless'], MAGIAS['fireball'], MAGIAS['magic-lock'], MAGIAS['poison'], MAGIAS['telekinesis'], MAGIAS['teleport'], MAGIAS['unlock'], MAGIAS['wall-of-stone']],
  [MAGIAS['arch-cure'], MAGIAS['arch-protection'], MAGIAS['curse'], MAGIAS['fire-field'], MAGIAS['greater-heal'], MAGIAS['lightning'], MAGIAS['mana-drain'], MAGIAS['recall']],
  [MAGIAS['blade-spirits'], MAGIAS['dispel-field'], MAGIAS['incognito'], MAGIAS['magic-reflection'], MAGIAS['mind-blast'], MAGIAS['paralyze'], MAGIAS['poison-field'], MAGIAS['summon-creature']],
  [MAGIAS['dispel'], MAGIAS['energy-bolt'], MAGIAS['explosion'], MAGIAS['invisibility'], MAGIAS['mark'], MAGIAS['mass-curse'], MAGIAS['paralyze-field'], MAGIAS['reveal']],
  [MAGIAS['chain-lightning'], MAGIAS['energy-field'], MAGIAS['flamestrike'], MAGIAS['gate-travel'], MAGIAS['mana-vampire'], MAGIAS['mass-dispel'], MAGIAS['meteor-swarm'], MAGIAS['polymorph']],
  [MAGIAS['earthquake'], MAGIAS['energy-vortex'], MAGIAS['resurrection'], MAGIAS['summon-air-elemental'], MAGIAS['summon-daemon'], MAGIAS['summon-earth-elemental'], MAGIAS['summon-fire-elemental'], MAGIAS['summon-water-elemental']]
];

/** Teto do fator — o mesmo `CombatMath.BonusMaximo` do servidor, sobrescrito pela tabela. */
export function bonusMagiaTeto(): number {
  return tabelaAtual().bonusTeto;
}

function encurtaTicks(ticks: number, velMagia = 0): number {
  const b = Math.min(tabelaAtual().bonusTeto, Math.max(0, velMagia));
  if (b <= 0) return ticks;
  return Math.max(1, Math.ceil(ticks / (1 + b)));
}

function cicloDaMagia(id: string): number {
  const m = tabelaAtual().magias.find(x => x.id === id);
  return m?.cicloS && m.cicloS > 0 ? m.cicloS : 2.5;
}

/** Tempo até conjurar de novo — o mesmo `CombatMath.CastTicks` do servidor. */
export function cicloMs(id: string, velMagia = 0): number {
  const ticks = Math.max(1, Math.ceil(cicloDaMagia(id) * 10));
  return encurtaTicks(ticks, velMagia) * 100;
}

/** A recarga própria da magia, em ms (techspec-combate-v2). 0 = só a conjuração. */
export function recargaMs(id: string): number {
  const m = tabelaAtual().magias.find(x => x.id === id);
  return m?.cdS && m.cdS > 0 ? Math.round(m.cdS * 1000) : 0;
}

/** Alias: o ciclo já é só a conjuração. */
export function castMs(id: string, velMagia = 0): number {
  return cicloMs(id, velMagia);
}

export function aplicarMagiasDaTabela(t: TabelaCombate): void {
  for (const m of t.magias) {
    if (!ehMagia(m.id)) continue;
    const cur = MAGIAS[m.id];
    cur.mana = m.mana;
    if (m.alcance != null) cur.alcance = m.alcance;
    if (m.atraso != null) cur.atrasoMs = m.atraso;
    if (m.danoMin != null) cur.danoMin = m.danoMin;
    if (m.danoMax != null) cur.danoMax = m.danoMax;
  }
}

const POR_PALAVRAS = new Map(Object.values(MAGIAS).map(m => [m.palavras, m]));

export function magiaPorPalavras(text: string): Magia | undefined {
  return POR_PALAVRAS.get(text);
}

/**
 * Arma + até dezesseis atalhos (28/10/2026; o servidor guarda os 17). Quantos aparecem é escolha do jogador
 * (Configurações › Interface › Barra de skills, 8 a 16).
 */
export const HOTBAR_SIZE = 17;

export const HOTBAR_VAZIA: readonly (MagiaId | null)[] = Array.from({ length: HOTBAR_SIZE }, () => null);

export function lerHotbar(raw: unknown): (string | null)[] {
  const arr = Array.isArray(raw) ? raw : [];
  const out: (string | null)[] = [];
  for (let i = 0; i < HOTBAR_SIZE; i++) {
    const v = arr[i];
    out.push(typeof v === 'string' && v.length > 0 ? v : null);
  }
  return out;
}

export function paraHotbar(slots: readonly (string | null)[]): (MagiaId | null)[] {
  return Array.from({ length: HOTBAR_SIZE }, (_, i) => {
    const v = slots[i];
    return v && ehMagia(v) ? v : null;
  });
}

export function emblemaDaPagina(pagina: number): string {
  const n = Math.min(8, Math.max(1, Math.trunc(pagina)));
  return `/sprites/itens/skills/circle-${n}.png`;
}
